import { useCallback, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { useAnswerFinishedGoodQuestions } from "../../../api/boms";
import { useFinishedGoodQuestionsContext } from "./FinishedGoodQuestionsContext";

export default function useFinishedGoodQuestionsForm() {
  const { bom } = useFinishedGoodQuestionsContext();
  const { mutateAsync: answerQuestions, isError, isSuccess } = useAnswerFinishedGoodQuestions();
  const navigate = useNavigate();
  const initialValues = useMemo(() => {
    const values = {};
    if (bom) {
      for (let i = 0; i < bom.FG_Qs.length; i += 1) {
        values[`question${i}`] = "N";
      }
    }
    return values;
  }, [bom]);

  const handleSubmit = useCallback(
    (values, { setSubmitting }) => {
      setSubmitting(true);
      const questionsWithAnswers = bom.FG_Qs.map((question, i) => ({
        rule_id: question.RuleID,
        accepted: values[`question${i}`] === "Y",
      }));
      answerQuestions({ bomId: bom.BOMID, body: { answers: questionsWithAnswers } })
        .catch(() => {})
        .finally(() => {
          setSubmitting(false);
        });
    },
    [bom, answerQuestions],
  );

  useEffect(() => {
    if (isError) {
      Swal.fire({
        title: "Error!",
        text: "Failed to submit answers. Pleas try again.",
        icon: "error",
      });
    } else if (isSuccess) {
      navigate("/dashboard/create-bill-of-material/component-details/", { replace: true });
    }
  }, [isError, isSuccess, navigate]);

  return useMemo(() => ({ initialValues, handleSubmit }), [initialValues, handleSubmit]);
}
